import { useCallback, useEffect, useState } from "react";

const useClickOutside = (callback: () => void) => {
  const [dom, setDom] = useState<HTMLElement | null>(null);

  const handleClick = useCallback(
    (e: MouseEvent) => {
      const target = e.target;

      if (!dom || !(target instanceof Element)) {
        return;
      }

      if (!dom.contains(target)) {
        callback();
      }
    },
    [callback, dom]
  );

  useEffect(() => {
    document.addEventListener("mousedown", handleClick);
    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, [handleClick]);

  return { setDom };
};

export default useClickOutside;
